var render = function render(_c,_vm){return _c('div',{staticClass:"copyright"},[_c('span',{staticClass:"text"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Convenia. Todos os direitos reservados ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }